module.exports = require("@agm/core/core.module");